import { render, staticRenderFns } from "./EditLayout.vue?vue&type=template&id=e2c086c6&"
import script from "./EditLayout.vue?vue&type=script&lang=js&"
export * from "./EditLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports